module.exports = __webpack_public_path__ + "img/shape2.5dd53519.svg";